import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsModuleInfo } from '@softapps/core';
import { registerApplication } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { FavoriteService } from './services/favorite.service';
import { BauprofiSupplierRepository } from './repositories/bauprofi-supplier.repository';
import { BauprofiSupplierService } from './services/bauprofi-supplier.service';
import { BauprofiSupplierConfigRepository } from './repositories/bauprofi-supplier-config.repository';
import { BauprofiSupplierConfigService } from './services/bauprofi-supplier-config.service';
import { BauprofiDataCarrierColumnsRepository } from './repositories/bauprofi-data-carrier-columns.repository';
import { BauprofiDataCarrierColumnsService } from './services/bauprofi-data-carrier-columns.service';

export const bauprofiProviders: Array<Provider | EnvironmentProviders> = [
  registerApplication({
    name: 'bauprofi',
    title: 'Baumarkt',
    icon: 'fa-regular fa-trowel-bricks',
    route: 'bauprofi',
    translations: { de },
  }),
  provideSoftAppsModuleInfo('Baumarkt', {
    key: 'bauprofi',
    library: '@softapps/dfh/bauprofi',
    description: 'Baumarkt-Lieferanten und Datenträger für DFH.',
  }),
  FavoriteService,
  BauprofiSupplierRepository,
  BauprofiSupplierService,
  BauprofiSupplierConfigRepository,
  BauprofiSupplierConfigService,
  BauprofiDataCarrierColumnsRepository,
  BauprofiDataCarrierColumnsService,
];
